/* Layer Palette*/
export enum CreditTransactionType {
  pmiAggXl = 'pmi_agg_xl',
  pmiQs = 'pmi_qs',
  pmiIln = 'pmi_iln',
  gseAggXl = 'gse_agg_xl',
  cmXol = 'cm_xol',
}

type CreditLayerPaletteType =
  | 'agg_xl' // Aggregate Excess of Loss / Reinsurance Excess of Loss
  | 'qs' // Quota Share
  | 'iln' // Insurance Linked Note / Capital Markets

type CreditLayerPaletteGroupType = 'pmi' | 'gse'
type CreditLayerPaletteGroup = {
  name: string
  type: CreditLayerPaletteGroupType
  items: readonly CreditLayerPaletteItem[]
}
export type CreditLayerPaletteItem = {
  id: CreditTransactionType
  name: string
  type: CreditLayerPaletteType
  group: CreditLayerPaletteGroupType
}

const CREDIT_XOL_NAME = 'Aggregate Excess of Loss'
const CREDIT_ILN_NAME = 'Insurance Linked Note'
const CREDIT_QS_NAME = 'Quota Share'
const CREDIT_GSE_XOL_NAME = 'Reinsurance Excess of Loss'
const CREDIT_GSE_CAP_MKT_NAME = 'Capital Markets'

export const CREDIT_TRANSACTION_TYPE_TO_NAME_MAP: Record<CreditTransactionType, string> = {
  pmi_agg_xl: CREDIT_XOL_NAME,
  pmi_iln: CREDIT_ILN_NAME,
  pmi_qs: CREDIT_QS_NAME,
  gse_agg_xl: CREDIT_GSE_XOL_NAME,
  cm_xol: CREDIT_GSE_CAP_MKT_NAME,
}

const CREDIT_LAYER_PALETTE_PMI: CreditLayerPaletteItem[] = [
  {
    id: CreditTransactionType.pmiAggXl,
    name: CREDIT_XOL_NAME,
    group: 'pmi',
    type: 'agg_xl',
  },
  {
    id: CreditTransactionType.pmiQs,
    name: CREDIT_QS_NAME,
    group: 'pmi',
    type: 'qs',
  },
  {
    id: CreditTransactionType.pmiIln,
    name: CREDIT_ILN_NAME,
    group: 'pmi',
    type: 'iln',
  },
]
const CREDIT_LAYER_PALETTE_GSE: CreditLayerPaletteItem[] = [
  {
    id: CreditTransactionType.gseAggXl,
    name: CREDIT_GSE_XOL_NAME,
    group: 'gse',
    type: 'agg_xl',
  },
  {
    id: CreditTransactionType.cmXol,
    name: CREDIT_GSE_CAP_MKT_NAME,
    group: 'gse',
    type: 'iln',
  },
]
export const CREDIT_LAYER_PALETTE: CreditLayerPaletteItem[] = [
  ...CREDIT_LAYER_PALETTE_PMI,
  ...CREDIT_LAYER_PALETTE_GSE,
]
export const CREDIT_LAYER_PALETTE_GROUPS: CreditLayerPaletteGroup[] = [
  {
    name: 'PMI',
    type: 'pmi',
    items: CREDIT_LAYER_PALETTE_PMI,
  },
  // {
  //   name: 'GSE',
  //   type: 'gse',
  //   items: CREDIT_LAYER_PALETTE_GSE,
  // },
]
export const CREDIT_LAYER_PALETTE_GROUPS_GSE: CreditLayerPaletteGroup[] = [
  {
    name: 'GSE',
    type: 'gse',
    items: [
      { id: CreditTransactionType.gseAggXl, name: CREDIT_GSE_XOL_NAME, group: 'gse', type: 'agg_xl' },
      // Quota Share hidden from the GSE layer type palette per client request - the client no
      // longer wants to offer it as a GSE layer type. Logic/model support is left intact; only
      // this UI entry point is hidden.
      // { id: CreditTransactionType.pmiQs, name: CREDIT_QS_NAME, group: 'pmi', type: 'qs' },
      { id: CreditTransactionType.cmXol, name: CREDIT_GSE_CAP_MKT_NAME, group: 'gse', type: 'iln' },
    ],
  },
]
export const CREDIT_LAYER_TYPE_TO_NAME_MAPPING: Map<CreditTransactionType, string> = [
  ...CREDIT_LAYER_PALETTE_GROUPS,
  ...CREDIT_LAYER_PALETTE_GROUPS_GSE,
].reduce((mapping, group) => {
  group.items.forEach((item) => {
    mapping.set(item.id, item.name)
  })
  return mapping
}, new Map<CreditTransactionType, string>())
